import ProspectLedDiscovery from "./ProspectLedDiscovery";

export default ProspectLedDiscovery;
